export default __webpack_public_path__ + "static/media/maintenance.dd74fcf1.png";